import { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { ShoppingBag } from "lucide-react";
import { useOrder } from "../context/OrderContext";

const FloatingCTA = () => {
  const [show, setShow] = useState(false);
  const openOrder = useOrder();

  useEffect(() => {
    const onScroll = () => setShow(window.scrollY > window.innerHeight * 0.9);
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <AnimatePresence>
      {show && (
        <>
          {/* Desktop floating pill */}
          <motion.button
            onClick={openOrder}
            data-testid="floating-order-btn"
            initial={{ opacity: 0, scale: 0.8, y: 20 }}
            animate={{ opacity: 1, scale: 1, y: 0 }}
            exit={{ opacity: 0, scale: 0.8, y: 20 }}
            transition={{ type: "spring", stiffness: 300, damping: 22 }}
            className="hidden md:flex fixed bottom-8 right-8 z-40 items-center gap-2.5 rounded-full bg-primary text-primary-foreground pl-6 pr-7 py-4 text-sm font-semibold tracking-wide shadow-warm-lg hover:scale-[1.04] transition-transform duration-300"
          >
            <ShoppingBag size={18} strokeWidth={1.8} />
            Order Online
          </motion.button>

          {/* Mobile sticky bar */}
          <motion.div
            initial={{ y: 80 }}
            animate={{ y: 0 }}
            exit={{ y: 80 }}
            transition={{ type: "spring", stiffness: 300, damping: 26 }}
            className="md:hidden fixed inset-x-0 bottom-0 z-40 p-3 bg-background/90 backdrop-blur-xl border-t border-surface"
          >
            <button
              onClick={openOrder}
              data-testid="mobile-sticky-order-btn"
              className="w-full flex items-center justify-center gap-2.5 rounded-full bg-primary text-primary-foreground py-4 text-sm font-semibold tracking-wide"
            >
              <ShoppingBag size={18} strokeWidth={1.8} />
              Order Online
            </button>
          </motion.div>
        </>
      )}
    </AnimatePresence>
  );
};

export default FloatingCTA;
